export const buildLoanPlansPayload = (selectedPlans, planDetails) => {
  return selectedPlans.map((planKey) => ({
    plan: planKey,
    graduation_date: planDetails[planKey]?.graduationDate || "",
    current_balance: planDetails[planKey]?.balance
      ? parseFloat(planDetails[planKey].balance)
      : 0,
    overpayment_type: planDetails[planKey]?.overpayment_type || "",
    overpayment_amount: planDetails[planKey]?.overpayment_amount !== undefined && planDetails[planKey]?.overpayment_amount !== ""
      ? parseFloat(planDetails[planKey].overpayment_amount)
      : 0,
    overpayment_lump_sum_whole_thing: Boolean(
      planDetails[planKey]?.overpayment_lump_sum_whole_thing
    ),
  }));
};

export const buildCalculationPayload = ({
  inputs,
  selectedPlans,
  planDetails,
  editedIncomes,
}) => {
  return {
    ...inputs,
    rpi: parseFloat(inputs.rpi),
    loan_plans: buildLoanPlansPayload(selectedPlans, planDetails),
    edited_incomes: editedIncomes,
  };
};
